import * as React from "react";
import { useSelector } from "react-redux";

import { useTable } from "@/react/components/table/useTable";
import TableComponent from "@/react/components/table/TableComponent";
import { tenantIdSelector } from "@/react/features/customer/customerSlice";
import { useErrorNotification } from "@/react/notifications";

import { useGetQueuesByMediaTypeQuery } from "@/react/features/vcc/common/api/queues";
import columnDefinition from "./columnDefinition";
import schema from "./schema";
import useMutations from "./useMutations";

const COLUMN_DEFINITION = columnDefinition();

const AllQueues = () => {
  const tenantName = useSelector(tenantIdSelector);
  const {
    data: initialData,
    isFetching,
    error,
    refetch,
  } = useGetQueuesByMediaTypeQuery({ tenantName });

  useErrorNotification(error);
  const { table, filters, state, mutations } = useTable(
    initialData,
    COLUMN_DEFINITION,
    schema,
    schema.fields.id.spec.key
  );
  const { onSave, onCancel, isMutationOngoing, filteredMutations, isDirty } =
    useMutations(tenantName, mutations);

  return (
    <TableComponent
      title="All Queues"
      schema={schema}
      isLoading={isFetching || isMutationOngoing}
      onRefresh={refetch}
      table={table}
      filters={filters}
      mutations={filteredMutations}
      state={state}
      isDirty={isDirty}
      onSave={onSave}
      onCancel={onCancel}
    />
  );
};

export default AllQueues;
